import React from 'react';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';
import styles from './styles';

const useStyles = createUseStyles(styles, 'Static');

function Static({ value, ...props }) {
    const classes = useStyles();

    return (
        <Text className={classes.root} {...props}>
            {value}
        </Text>
    );
}

export default React.memo(Static);
